import { render, staticRenderFns } from "./BottomPopup.vue?vue&type=template&id=71fdef73&scoped=true"
import script from "./BottomPopup.vue?vue&type=script&lang=js"
export * from "./BottomPopup.vue?vue&type=script&lang=js"
import style0 from "./BottomPopup.vue?vue&type=style&index=0&id=71fdef73&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdef73",
  null
  
)

export default component.exports